import { useMemo } from 'react';
import styled from 'styled-components';
import { checkIsTrustedProvider, getSrcFromIframeBody, isHubSpotContent } from '../../../lib/iframe/getIframeContentProvider';
import { useEmbedIframeReport } from './useIframe';
import { jsx as _jsx } from "react/jsx-runtime";
// allow-popups - allow opening new tabs as well as pop-ups, required by tableau to login
// allow-forms - powerpoint, MS word, & some logins require this
// Note: We don't allow forms for all content to help prevent possible phishing attempts
const TRUSTED_PROVIDER_PERMISSIONS = 'allow-popups allow-downloads allow-forms allow-modals allow-popups-to-escape-sandbox';
const StyledIframe = styled.iframe.withConfig({
  displayName: "DashboardIframeEmbed__StyledIframe",
  componentId: "sc-1ao60rc-0"
})(({
  isContentLoaded,
  theme
}) => `
  height: 100%;
  width: 100%;
  border-width: ${theme.borderWidth[0]};
  display: ${isContentLoaded ? 'block' : 'none'};
`);
const IframeEmbed = props => {
  const {
    html,
    onSetContentDone,
    reportId
  } = props;
  const {
    iframeWidgetKey,
    src,
    isContentLoaded,
    getRefFromElement
  } = useEmbedIframeReport({
    html,
    onSetContentDone,
    reportId
  });
  const isTrustedProvider = checkIsTrustedProvider(html);
  return /*#__PURE__*/_jsx(StyledIframe, {
    allowFullScreen: isTrustedProvider,
    contentEditable: false,
    isContentLoaded: isContentLoaded,
    src: src,
    sandbox: `allow-scripts allow-same-origin ${isTrustedProvider ? TRUSTED_PROVIDER_PERMISSIONS : ''}`,
    referrerPolicy: "strict-origin",
    ref: getRefFromElement
  }, iframeWidgetKey);
};
export const DashboardIframeEmbed = ({
  html,
  onSetContentDone,
  reportId
}) => {
  const isHubSpotEmbed = useMemo(() => isHubSpotContent(html), [html]);
  if (isHubSpotEmbed) {
    const originalHubspotUrl = getSrcFromIframeBody(html, true);
    if (originalHubspotUrl) {
      const hubspotUrl = originalHubspotUrl.replace(/&amp;/g, '&');
      const relativeUrlStart = hubspotUrl.indexOf('.com') + '.com'.length;
      return /*#__PURE__*/_jsx(StyledIframe, {
        allowFullScreen: true,
        isContentLoaded: true,
        contentEditable: false,
        src: hubspotUrl.slice(relativeUrlStart),
        sandbox: `allow-scripts allow-same-origin ${TRUSTED_PROVIDER_PERMISSIONS}`,
        referrerPolicy: "strict-origin"
      }, `dashboard-iframe-${reportId}`);
    }
  }
  return /*#__PURE__*/_jsx(IframeEmbed, {
    html: html,
    onSetContentDone: onSetContentDone,
    reportId: reportId
  });
};